/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Gray_Lion_RollInputs */

const en_mild_gray_lion_roll = /** @type {(inputs: Mild_Gray_Lion_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With comments`)
};

const de_mild_gray_lion_roll = /** @type {(inputs: Mild_Gray_Lion_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare freigegeben`)
};

/**
* | output |
* | --- |
* | "With comments" |
*
* @param {Mild_Gray_Lion_RollInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_gray_lion_roll = /** @type {((inputs?: Mild_Gray_Lion_RollInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Gray_Lion_RollInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_gray_lion_roll(inputs)
	return de_mild_gray_lion_roll(inputs)
});